import {
  getDesktopSheetStyle,
  getServiceSearchQuery,
  isDesktopWebLayout,
  subscribeServiceSearch,
} from "@/lib/desktop-layout";
import { useSyncExternalStore } from "react";
import { Platform, useWindowDimensions } from "react-native";

export function useDesktopLayout(): boolean {
  const { width } = useWindowDimensions();
  return isDesktopWebLayout(Platform.OS, width);
}

export function useDesktopSheetStyle(): ReturnType<typeof getDesktopSheetStyle> {
  return getDesktopSheetStyle(useDesktopLayout());
}

export function useServiceSearchQuery(): string {
  return useSyncExternalStore(
    subscribeServiceSearch,
    getServiceSearchQuery,
    getServiceSearchQuery,
  );
}
